import type {SenderAddressOption} from './types';

export const IMAGE_UPLOAD_OPTIONS = {
    maxSize: 10485760,
    accept: 'image/*',
};

export const INTERNAL_NOTE_OPTION_VALUE = 'INTERNAL_NOTE';
export const INTERNAL_NOTE_OPTION: SenderAddressOption = {
    value: INTERNAL_NOTE_OPTION_VALUE,
    label: 'Add an internal note',
};
